import {
    FaHome, FaUserShield, FaEnvelopeOpenText, FaUsers, FaWarehouse, FaWindowRestore,
    FaChartBar, FaAngleRight, FaGenderless, FaCompressAlt, FaExpandAlt, FaFileInvoice, FaNewspaper, FaRegNewspaper
} from "react-icons/fa";
import { useSelector } from 'react-redux'
import { useRef } from "react";
import { useNavigate } from 'react-router-dom'

import { SidebarWrapper } from "./styled"
import NoBody from 'assets/images/no-avatar.png'
import { authSelector } from 'redux/selector'
import { role } from "common/general";

function AdminSideBar({ tab, setTab, size, isFullSize, handleChangeSizeSideBar }) {
    const authState = useSelector(authSelector)

    const avatarRef = useRef()
    const navigate = useNavigate()
    const handleSetTab = (value) => {
        setTab(value)
        switch (value) {
            case 'staff':
                navigate('/admin/staff?page=1')
                break;
            case 'customer':
                navigate('/admin/customer?page=1')
                break;
            case 'tour-type':
                navigate('/admin/tour-type?page=1')
                break;
            case 'tour':
                navigate('/admin/tour?page=1')
                break;
            case 'news-category':
                navigate('/admin/news-category?page=1')
                break;
            case 'news':
                navigate('/admin/news?page=1')
                break;
            case 'order':
                navigate('/admin/order?page=1')
                break;
            case 'bill':
                navigate('/admin/bill?page=1')
                break;
            default:
                navigate('/admin/dashboard')
                break;
        }
    }

    const handleErrorAvatar = () => {
        avatarRef.current.src = NoBody
    }

    return (
        <SidebarWrapper className="admin_sidebar bg-color23"
            style={{ minWidth: size + 'px', maxWidth: size + 'px' }}
        >
            <div className='admin_sidebar_info bb-color1-1 py-25 px-0'>
                <div className='admin_sidebar_info_image'>
                    <div
                        style={isFullSize ? { width: '130px', height: '130px' } : { width: '80px', height: '80px', marginTop: '12px' }}
                    >
                        <img src={authState.currentUser.user.avatar || NoBody}
                            alt='avatar'
                            className="avatar"
                            ref={avatarRef}
                            onError={handleErrorAvatar} />
                    </div>
                </div>
                {
                    isFullSize &&
                    <div className='admin_sidebar_info_name'>
                        <div className="mt-20">
                            <span className="text-color4 s-22">
                                {
                                    authState.currentUser?.user.account_name
                                }
                            </span>
                            <p className="text-color14 s-14"><i><FaGenderless /></i>
                                {
                                    authState.role === role.STAFF &&
                                    'Nhân viên'
                                }
                                {
                                    authState.role === role.ADMIN &&
                                    'Quản lý'
                                }
                            </p>
                        </div>
                    </div>
                }
                <span onClick={handleChangeSizeSideBar} className="admin_sidebar_change-size">
                    {
                        isFullSize ?
                            <FaCompressAlt /> : <FaExpandAlt />
                    }
                </span>
            </div>
            <ul className='admin_sidebar_menu mx-0 my-0 px-0'>
                {
                    authState.role === role.ADMIN &&
                    <li
                        className={`admin_sidebar_menu_item
                        ${tab === 'staff' ? 'admin_sidebar_menu_item-active' : ''}
                    `}
                        onClick={() => handleSetTab('staff')}>
                        <div>
                            <i><FaUserShield /></i>
                            {
                                isFullSize &&
                                <span>Quản lý nhân viên</span>
                            }
                        </div>
                        <i><FaAngleRight /></i>
                    </li>
                }
                <li
                    className={`admin_sidebar_menu_item
                        ${tab === 'customer' ? 'admin_sidebar_menu_item-active' : ''}`}
                    onClick={() => handleSetTab('customer')}>
                    <div>
                        <i><FaUsers /></i>
                        {
                            isFullSize &&
                            <span>Quản lý khách hàng</span>
                        }
                    </div>
                    <i><FaAngleRight /></i>
                </li>
                <li
                    className={`admin_sidebar_menu_item
                        ${tab === 'tour-type' ? 'admin_sidebar_menu_item-active' : ''}`}
                    onClick={() => handleSetTab('tour-type')}>
                    <div>
                        <i><FaWarehouse /></i>
                        {
                            isFullSize &&
                            <span>Quản lý loại tour</span>
                        }
                    </div>
                    <i><FaAngleRight /></i>
                </li>
                <li
                    className={`admin_sidebar_menu_item
                        ${tab === 'tour' ? 'admin_sidebar_menu_item-active' : ''}
                    `}
                    onClick={() => handleSetTab('tour')}>
                    <div>
                        <i><FaWindowRestore /></i>
                        {
                            isFullSize &&
                            <span>Quản lý tour</span>
                        }
                    </div>
                    <i><FaAngleRight /></i>
                </li>
                <li
                    className={`admin_sidebar_menu_item
                        ${tab === 'order' ? 'admin_sidebar_menu_item-active' : ''}
                    `}
                    onClick={() => handleSetTab('order')}>
                    <div>
                        <i><FaEnvelopeOpenText /></i>
                        {
                            isFullSize &&
                            <span>Quản lý đặt tour</span>
                        }
                    </div>
                    <i><FaAngleRight /></i>
                </li>
                <li
                    className={`admin_sidebar_menu_item
                        ${tab === 'bill' ? 'admin_sidebar_menu_item-active' : ''}
                    `}
                    onClick={() => handleSetTab('bill')}>
                    <div>
                        <i><FaChartBar /></i>
                        {
                            isFullSize &&
                            <span>Thống kê</span>
                        }
                    </div>
                    <i><FaAngleRight /></i>
                </li>
                <li
                    className={`admin_sidebar_menu_item
                        ${tab === 'news-category' ? 'admin_sidebar_menu_item-active' : ''}
                    `}
                    onClick={() => handleSetTab('news-category')}>
                    <div>
                        <i><FaNewspaper /></i>
                        {
                            isFullSize &&
                            <span>Quản lý loại bài viết</span>
                        }
                    </div>
                    <i><FaAngleRight /></i>
                </li>
                <li
                    className={`admin_sidebar_menu_item 
                        ${tab === 'news' ? 'admin_sidebar_menu_item-active' : ''}
                    `}
                    onClick={() => handleSetTab('news')}>
                    <div>
                        <i><FaRegNewspaper /></i>
                        {
                            isFullSize &&
                            <span>Quản lý bài viết</span>
                        }
                    </div>
                    <i><FaAngleRight /></i>
                </li>
            </ul>
        </SidebarWrapper >
    );
}

export default AdminSideBar;